import { admins_api_complaints_delete_url } from "@/mk/urls/functions";

export function deleteComplaints(
    xhr,
    entity: string,
    id: number,
    optionalArgs?: { complaintId?: number; deleteSubtree?: boolean },
) {
    return xhr.post(admins_api_complaints_delete_url(entity, id), { ...optionalArgs });
}
